<template>
  <img 
    src="/src/assets/icons/en.svg" 
    alt="English flag"
    class="w-4 h-4 object-cover rounded-sm"
  />
</template> 